module.exports = __webpack_public_path__ + "static/media/sa1.3bbeb866.jpg";